<template>
  <div class="row">
    <div class="col-md-8">
      <b-card header-tag="header" footer-tag="footer">
        <template #header>
          <h6 class="mb-0 d-flex">
            <div>
              ID: <strong>{{reservation.code}}</strong> <small>Creada {{ $moment(reservation.created_at).format('YYYY-MM-DD HH:mm:ss') }}</small>
            </div>
            <strong class="ml-auto">
              ${{ numberFormat(reservation.total) }}{{ reservation.currency }}
            </strong>
          </h6>
        </template>
        <b-card-text text-tag="div">
          <div class="row">
            <div class="col-md-4">
              <b-form-group
                id="fieldset-1"
                description="Nombre completo."
                label="Cliente"
                label-for="input-1"
              >
                <b-form-input id="input-1" v-model="reservation.customer_name" readonly trim></b-form-input>
              </b-form-group>
            </div>
            <div class="col-md-4">
              <b-form-group
                id="fieldset-2"
                description="Tipo de vehiculo"
                label="Producto"
                label-for="input-2"
              >
                <b-form-input id="input-2" v-model="reservation.service_name" readonly trim></b-form-input>
              </b-form-group>
            </div>
            <div class="col-md-4">
              <b-form-group
                id="fieldset-3"
                description="Tipo de servicio"
                label="Servicio"
                label-for="input-3"
              >
                <b-form-input id="input-3" v-model="reservation.service_type" readonly trim></b-form-input>
              </b-form-group>
            </div>
          </div>
          <div class="row">
            <div class="col-md-4">
              <b-form-group
                id="fieldset-4"
                description=""
                label="Desde"
                label-for="input-4"
              >
                <b-form-input id="input-4" v-model="reservation.from_hotel" readonly trim></b-form-input>
              </b-form-group>
            </div>
            <div class="col-md-4">
              <b-form-group
                id="fieldset-5"
                description="Hotel"
                label="Hacia"
                label-for="input-5"
              >
                <b-form-input id="input-5" v-model="reservation.to_hotel" readonly trim></b-form-input>
              </b-form-group>
            </div>
            <div class="col-md-4">
              <b-form-group
                id="fieldset-6"
                description="# de clientes"
                label="Pax"
                label-for="input-6"
              >
                <b-form-input id="input-6" v-model="reservation.pax" readonly trim></b-form-input>
              </b-form-group>
            </div>
          </div>
          <hr>
          <div class="row">
            <div class="col-md-4">
              <b-form-group
                id="fieldset-13"
                description=""
                label="Email"
                label-for="input-13"
              >
                <b-form-input id="input-13" v-model="reservation.contact_email" readonly trim></b-form-input>
              </b-form-group>
            </div>
            <div class="col-md-4">
              <b-form-group
                id="fieldset-14"
                description=""
                label="Tel"
                label-for="input-14"
              >
                <b-form-input id="input-14" v-model="reservation.contact_phone" readonly trim></b-form-input>
              </b-form-group>
            </div>
            <div class="col-md-4">
              <b-form-group
                id="fieldset-15"
                description=""
                label="País"
                label-for="input-15"
              >
                <b-form-input id="input-15" v-model="reservation.contact_country" readonly trim></b-form-input>
              </b-form-group>
            </div>
          </div>
        </b-card-text>
      </b-card>
      <b-card v-if="reservation.service_type == 'arrival' || reservation.service_type == 'round trip'" class="mt-3" header-tag="header">
        <template #header>
          <h6 class="mb-0">
            <strong class="">
              LLegada
            </strong>
          </h6>
        </template>
        <b-card-text text-tag="div">
          <div class="row">
            <div class="col-md-4">
              <b-form-group
                id="fieldset-7"
                description=""
                label="Fecha y hora"
                label-for="input-7"
              >
                <b-form-input id="input-7" :value="$moment(reservation.arrival_date).format('DD MMM YYYY HH:mm')" readonly trim></b-form-input>
              </b-form-group>
            </div>
            <div class="col-md-4">
              <b-form-group
                id="fieldset-8"
                description=""
                label="Aerolinea"
                label-for="input-8"
              >
                <b-form-input id="input-8" v-model="reservation.arrival_airline" readonly trim></b-form-input>
              </b-form-group>
            </div>
            <div class="col-md-4">
              <b-form-group
                id="fieldset-9"
                description=""
                label="#Vuelo"
                label-for="input-9"
              >
                <b-form-input id="input-9" v-model="reservation.arrival_flight" readonly trim></b-form-input>
              </b-form-group>
            </div>
          </div>
        </b-card-text>
      </b-card>
      <b-card v-if="reservation.service_type == 'departure' || reservation.service_type == 'round trip'" class="mt-3" header-tag="header">
        <template #header>
          <h6 class="mb-0">
            <strong class="">
              Salida
            </strong>
          </h6>
        </template>
        <b-card-text text-tag="div">
          <div class="row">
            <div class="col-md-4">
              <b-form-group
                id="fieldset-10"
                description=""
                label="Fecha y hora"
                label-for="input-10"
              >
                <b-form-input id="input-10" :value="$moment(reservation.departure_date).format('DD MMM YYYY HH:mm')" readonly trim></b-form-input>
              </b-form-group>
            </div>
            <div class="col-md-4">
              <b-form-group
                id="fieldset-11"
                description=""
                label="Aerolinea"
                label-for="input-11"
              >
                <b-form-input id="input-11" v-model="reservation.departure_airline" readonly trim></b-form-input>
              </b-form-group>
            </div>
            <div class="col-md-4">
              <b-form-group
                id="fieldset-12"
                description=""
                label="#Vuelo"
                label-for="input-12"
              >
                <b-form-input id="input-12" v-model="reservation.departure_flight" readonly trim></b-form-input>
              </b-form-group>
            </div>
          </div>
        </b-card-text>
      </b-card>
      <b-card  class="mt-3" header-tag="header">
        <template #header>
          <h6 class="mb-0">
            <strong class="">
              Totales
            </strong>
          </h6>
        </template>
        <b-card-text text-tag="div">
          <table class="table">
            <tbody>
              <tr>
                <td><strong>Total</strong></td>
                <td><strong>${{numberFormat(reservation.total)}}{{reservation.currency}}</strong></td>
              </tr>
              <tr>
                <td>Base</td>
                <td>${{numberFormat(reservation.base_total)}}{{reservation.currency}}</td>
              </tr>
              <tr>
                <td class="text-primary">Cuota</td>
                <td class="text-primary">${{numberFormat(reservation.quota)}}{{reservation.currency}}</td>
              </tr>
              <tr>
                <td class="text-success">Excedente</td>
                <td class="text-success">${{numberFormat(getCommission())}}{{reservation.currency}}</td>
              </tr>
            </tbody>
          </table>
        </b-card-text>
      </b-card>
    </div>
    <div class="col-md-4"></div> 
  </div>
</template>
<script>
  import {NumberFormat} from "../../helpers/NumberFormat"
  export default {
    name:'ReservationSeller',
    props:['reservation'],
    methods:{
      numberFormat(number) {
        return NumberFormat.format(parseFloat(number), 2, ',', '.')
      },
      getCommission() {
        return parseFloat(this.reservation.total) - (parseFloat(this.reservation.base_total) + parseFloat(this.reservation.quota))
      }
    }
  }
</script>